












































































































import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { EventBus, hasElements, TypeEventBus, sortObjectByPropertyName, getIndexFromList, excludeIdFromList } from '../../core/utils';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import { FilterDateEvent } from '../../core/utils/types';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import Axios from 'axios';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import CreateFrame from '../components/CreateFrame.vue';
import { NormsServices } from '../api/NormsServices';
import { PageTitle } from '../../core/components';
import Input from '../../core/components/Input.vue'; 
import SimpleTable from '../../core/components/SimpleTable.vue'; 

@Component({
    components: {
        CreateFrame,
        PageTitle,
        Input,
        SimpleTable
    }
})
export default class NormasFramesList extends Mixins(CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper) {
    //create frame props
    visibleModalCreateFrame: boolean = false;
    framesTypes: any = [];
    frameToPatch: any = {};
    currentAction: string = '';
    categoriesOptions: any = [];
    editingFrame: boolean = false;

    //frames list
    sortBy: string[] = ['id'];
    sortDesc: boolean[] = [true];
    dataAssigned: boolean = false;
    loadingPreviewData: boolean = false;
    previewFrame: object = {};
    showModalCreateEcu: boolean = false;
    frameToDelete: number | null = null;
    pendingRequest: boolean = false;
    showDeleteConfirmationDialog: boolean = false;
    deleteConfirmationTitle: string = 'Eliminar Frame';
    deleteConfirmationMessage: string = '¿Está seguro que desea eliminar esta Frame? Ésta acción no se podrá deshacer.';
    search: string = '';
    pendingProtocols: boolean = false;
    protocolSelected: any = null;
    protocolOptions: any = [];
    headers: any[] = [
        {
            text: 'ID',
            align: 'center',
            value: 'id',
            tooltip: '',
            width: '100px'
        },
        {
            text: 'Descripción',
            align: 'left',
            value: 'description',
            tooltip: ''
        },
        {
            text: 'Categoría',
            align: 'left',
            value: 'category',
            tooltip: ''
        },
        {
            text: 'Protocolo',
            align: 'center',
            value: 'protocol',
            width: '200',
            tooltip: ''
        },
        {
            text: 'N° Ecus Activas',
            align: 'center',
            value: 'ecu_count',
            width: '200',
            tooltip: 'Indica si se encuentra activa en alguna ECU'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions',
            sortable: false,
            tooltip: ''
        }
    ];
    items: any = [];
    pagination: object = {
        rowsPerPageItems: 18
    };
    protocolTypes: any = [];
    pendingRequestPatchFrame: boolean = false;

    mounted() {
        this.$nextTick(() => {
            this.getFramesList();
        })
    }

    updateSearchValue(value){
        this.search = value;
    }

    @Watch('$_getNormsProperties')
    watchNormsProperties() {
        this.dataAssigned = false;
        this.assignVariables();
    }

    convertDictionaryToList(obj) {
        let items: any = [];
        for (let i = 0; i < Object.keys(obj).length; i++) {
            items.push({
                id: Object.keys(obj)[i],
                value: Object.values(obj)[i]
            });
        }
        items.sort(sortObjectByPropertyName('value'));
        return items;
    }

    getDataFromNormsProperties(option) {
        return this.$_getNormsProperties[option];
    }

    trucate(value, length = 200) {
        return value.length <= length ? value : value.substring(0, length) + '...';
    }

    getFramesList() {
        this.pendingRequest = true;
        NormsServices.getFramesList(Axios.CancelToken.source())
            .then(response => {
                this.pendingRequest = false;
                this.items = response.map(function(item){
                    return {
                        ...item,
                        disableDelete: item['ecu_count'] > 0 ? true : false
                    }
                });
                this.checkIfUrlHasFrameId();
                this.assignVariables();
            })
            .catch(error => {
                this.pendingRequest = false;
                this.assignVariables();
            })
    }

    checkIfUrlHasFrameId() {
        let frameId = this.$route.params.id;
        if (frameId) {
            let frameIdInTable = this.items.findIndex(item => item['id'] === Number(frameId));
            if (frameIdInTable !== -1) {
                this.modifyFrame(this.items[frameIdInTable], true);
            }
        }
    }

    assignVariables() {
        this.protocolTypes = this.convertDictionaryToList(this.getDataFromNormsProperties('all_protocols'));
        this.categoriesOptions = this.getDataFromNormsProperties('all_categories_flag');
        this.framesTypes = this.convertDictionaryToList(this.getDataFromNormsProperties('all_frame_types'));
        this.dataAssigned = true;
    }

    createFrame() {
        this.protocolSelected = null;
        this.editingFrame = false;
        this.frameToPatch = {};
        this.visibilityModalCreateFrame(true);
    }

    backToNormas() {
        this.$router.push(NAME_ROUTES.NORMAS.path);
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    visibilityModalCreateFrame(value) {
        this.visibleModalCreateFrame = value;
        this.handleListenKey(false);
    }

    closeModalCreateFrame() {
        this.visibilityModalCreateFrame(false);
    }

    getIndexId(list, id){
        return getIndexFromList(list, 'id', id);
    }

    addNewFrame(newFrame) {
        let categoryId = newFrame['category_id'];
        let frameId = newFrame['id'];
        let categoryToAdd = this.getIndexId(this.categoriesOptions, categoryId);

        let frameToPush = {
            id: frameId,
            description: newFrame['description'],
            category: this.categoriesOptions[categoryToAdd]['description'],
            protocol: newFrame['protocol'],
            ecu_count: newFrame['ecu_count']
        };

        this.items.push(frameToPush);
        this.loadingParamsEffect();
        this.$_successPatchRecipients('Frame agregado');
    }

    createFileFromThis(item) {
        this.modifyFrame(item, false, 'createFromThis');
    }

    updateProtocolSelected(option) {
        this.protocolSelected = option;
    }

    loadingParamsEffect() {
        this.pendingRequest = true;
        let allParams = this.items;
        this.items = [];
        this.items = allParams;

        setTimeout(() => {
            this.pendingRequest = false;
        }, 200);
    }

    updateFrame(newFrame, removedParams) {
        let indexFrameInList =  this.getIndexId(this.items, newFrame['id']);
        let indexCat =this.getIndexId(this.categoriesOptions, newFrame['category_id']);

        if (indexFrameInList !== -1) {
            this.$set(this.items[indexFrameInList], 'description', newFrame['description']);
            this.$set(this.items[indexFrameInList], 'ecu_count', newFrame['ecu_count']);
            this.$set(this.items[indexFrameInList], 'category', this.categoriesOptions[indexCat]['description']);
            this.$set(this.items[indexFrameInList], 'id', newFrame['id']);
        }

        this.loadingParamsEffect();
        this.$_successPatchRecipients('Frame actualizado');
    }

    modifyFrame(frame, editingFrame: boolean, loadingKey?: string) {
        let self = this;
        let loadingKei = loadingKey ? loadingKey : editingFrame ? 'isLoading' : 'isPreviewing';
        let isEditing = editingFrame;
        this.frameToPatch = {};
        this.$set(frame, loadingKei, true);
        NormsServices.getFrameDetail(frame['id'])
            .then(response => {
                let frameData = {};
                let indexProtocolType =  getIndexFromList(this.protocolTypes, 'value', frame['protocol']);
                let protocolName = this.protocolTypes[indexProtocolType]['value'];
                let protocolKey = protocolName.toLowerCase();
                frameData = response[protocolKey];

                self.protocolSelected = self.protocolTypes[indexProtocolType];

                if(frameData['filterdataarray'] == null){
                    frameData['filterdataarray'] = ''
                }
                if(frameData['filtermaskarray'] == null){
                    frameData['filtermaskarray'] = ''
                }
                if(frameData['filterposition'] == null){
                    frameData['filterposition'] = ''
                }
                if(frameData['filterlength'] == null){
                    frameData['filterlength'] = ''
                }
                if(response['framearray'] === '{}'){
                    response['framearray'] = ''
                }

                self.$set(frameData, 'description', response['description']);
                self.$set(frameData, 'type', response['type']);
                self.$set(frameData, 'broadcasted', response['broadcasted']);
                self.$set(frameData, 'updatedperiodically', response['updatedperiodically']);
                self.$set(frameData, 'updatedonetime', response['updatedonetime']);
                self.$set(frameData, 'updatedonrequest', response['updatedonrequest']);
                self.$set(frameData, 'period', response['period']);
                self.$set(frameData, 'validitytime', response['validitytime']);
                self.$set(frameData, 'framelength', response['framelength']);
                self.$set(frameData, 'framearray', response['framearray']);
                self.$set(frameData, 'category', response['category']);
                self.$set(frameData, 'protocol_type', response['protocol_type']);
                self.$set(frameData, 'id', frame['id']);
                self.$set(frameData, 'parameter_list', response['parameter_list']);
                self.$set(frameData, 'ecu_count', response['ecu_count']);

                self.frameToPatch = frameData;
                self.editingFrame = isEditing;
                self.visibilityModalCreateFrame(true);
                this.$set(frame, loadingKei, false);
            })
            .catch(error => {
                // self.handleCatchResponse(error);
                this.$set(frame, loadingKei, false);
                this.frameToPatch = {};
            })
    }

    deleteFrame(item) {
        this.frameToDelete = Number(item['id']);
        this.showDeleteConfirmationDialog = true;
    }

    closeDeleteConfirmationDialog(confirm: boolean) {
        if (confirm) {
            this.pendingRequest = true;

            let idframeToDelete: any = this.frameToDelete;
            let self = this;

            NormsServices.deleteFrameById(idframeToDelete)
                .then(response => {
                    this.items = excludeIdFromList(this.items, idframeToDelete);
                    if (response && response.data && response.data.message) {
                        self.$_successDeleteRecipients(response['data']['message']);
                    } else {
                        self.$_successDeleteRecipients('Frame eliminada con éxito');
                    }
                    self.pendingRequest = false;
                })
                .catch(error => {
                    if (error && error.response && error.response.data && error.response.data.message) {
                        self.$_errorPatchRecipients(error.response.data.message);
                    } else {
                        self.$_errorPatchRecipients('No se pudo eliminar la Frame');
                    }
                    this.pendingRequest = false;
                });
        }
        this.showDeleteConfirmationDialog = false;
    }
}
